var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useImperativeHandle, useRef, useEffect, forwardRef } from 'react';
import classNames from 'classnames';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
const ScrollView = (_a, ref) => {
    var { className, scrollX, scrollY, upperThreshold = 50, lowerThreshold = 50, scrollTop, scrollLeft, scrollIntoView, scrollIntoViewAlignment, scrollWithAnimation, 
    // TODO: 待实现
    // enableBackToTop,
    children, onScrollToUpper, onScrollToLower, onScroll } = _a, rest = __rest(_a, ["className", "scrollX", "scrollY", "upperThreshold", "lowerThreshold", "scrollTop", "scrollLeft", "scrollIntoView", "scrollIntoViewAlignment", "scrollWithAnimation", "children", "onScrollToUpper", "onScrollToLower", "onScroll"]);
    const el = useRef(null);
    const lastTop = useRef(0);
    const lastLeft = useRef(0);
    const props = useTaroBaseEvents(rest);
    useImperativeHandle(ref, () => el.current);
    useEffect(() => {
        if (el.current) {
            const { scrollTop, scrollLeft } = el.current;
            lastTop.current = scrollTop;
            lastLeft.current = scrollLeft;
        }
    }, []);
    useEffect(() => {
        if (el.current &&
            scrollY &&
            typeof scrollTop === 'number' &&
            scrollTop !== lastTop.current) {
            el.current.scrollTo({
                top: scrollTop,
                behavior: scrollWithAnimation ? 'smooth' : 'auto'
            });
        }
    }, [scrollTop]);
    useEffect(() => {
        if (el.current &&
            scrollX &&
            typeof scrollLeft === 'number' &&
            scrollTop !== lastLeft.current) {
            el.current.scrollTo({
                left: scrollLeft,
                behavior: scrollWithAnimation ? 'smooth' : 'auto'
            });
        }
    }, [scrollLeft]);
    useEffect(() => {
        if (!el.current || !scrollIntoView) {
            return;
        }
        const node = el.current.querySelector(`#${scrollIntoView}`);
        if (!node) {
            return;
        }
        node.scrollIntoView({
            behavior: scrollWithAnimation ? 'smooth' : 'auto',
            block: scrollY ? (scrollIntoViewAlignment || 'center') : 'center',
            inline: scrollX ? (scrollIntoViewAlignment || 'start') : 'start'
        });
    }, [scrollIntoView]);
    function createTaroUIEvent(taroEventType, reactEvent) {
        const { timeStamp, target, currentTarget } = reactEvent;
        const { scrollLeft, scrollTop, scrollHeight, scrollWidth } = target;
        const taroEvent = {
            type: taroEventType,
            timeStamp,
            target,
            currentTarget,
            detail: {
                scrollLeft,
                scrollTop,
                scrollHeight,
                scrollWidth,
                deltaX: lastLeft.current - scrollLeft,
                deltaY: lastTop.current - scrollTop
            },
            preventDefault: () => reactEvent.preventDefault(),
            stopPropagation: () => reactEvent.stopPropagation()
        };
        return taroEvent;
    }
    return (_jsx("div", Object.assign({}, props, { ref: el, className: classNames('taro-scroll', {
            'taro-scroll-view__scroll-x': scrollX,
            'taro-scroll-view__scroll-y': scrollY
        }, className), onScroll: event => {
            if (onScroll) {
                const taroEvent = createTaroUIEvent('scroll', event);
                onScroll(taroEvent);
            }
            const { offsetWidth, offsetHeight, scrollLeft, scrollTop, scrollHeight, scrollWidth } = el.current;
            if (onScrollToLower) {
                if ((scrollY && offsetHeight + scrollTop + lowerThreshold >= scrollHeight) ||
                    (scrollX && offsetWidth + scrollLeft + lowerThreshold >= scrollWidth)) {
                    const taroEvent = createTaroUIEvent('scrolltolower', event);
                    onScrollToLower(taroEvent);
                }
            }
            if (onScrollToUpper) {
                if ((scrollY && scrollTop <= upperThreshold) ||
                    (scrollX && scrollLeft <= upperThreshold)) {
                    const taroEvent = createTaroUIEvent('scrolltoupper', event);
                    onScrollToUpper(taroEvent);
                }
            }
            lastTop.current = scrollTop;
            lastLeft.current = scrollLeft;
        } }, { children: children })));
};
export default forwardRef(ScrollView);
